import { api } from '../../../../lib/api';
import type { PortalAssetsApi, PortalAssetsBulkApi } from '../../../portalAssets';
import { listQueryString } from '../../../portalAssets';

// THE CLIENT'S PortalAssetsApi — the one file that names /api/portal/assets.
//
// ⚠️ Every call is behind requirePortalAuth + the `assets` permission, and the
// scope is resolved server-side from the session. An `accountId` sent here can
// only SELECT within that scope; one outside it is a 404.

const BASE = '/api/portal/assets';

export const portalAssetsApi: PortalAssetsApi = {
  cacheKey: 'portal',
  list: (params) => api(`${BASE}${listQueryString(params)}`),
  detail: (assetId) => api(`${BASE}/${encodeURIComponent(assetId)}`),
  patch: (assetId, patch) =>
    api(`${BASE}/${encodeURIComponent(assetId)}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(patch),
    }),
  remove: (assetId) => api(`${BASE}/${encodeURIComponent(assetId)}`, { method: 'DELETE' }),
  enrich: (assetId) =>
    api(`${BASE}/${encodeURIComponent(assetId)}/enrich`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({}),
    }),
  review: (assetId, input) =>
    api(`${BASE}/${encodeURIComponent(assetId)}/review`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(input),
    }),
  history: (assetId) => api(`${BASE}/${encodeURIComponent(assetId)}/history`),
  // ⚠️ The client route takes no account: it answers for the whole operational
  // scope, and the page narrows to the selected account itself.
  counts: () => api(`${BASE}/counts`),
  categories: (accountId) => api(`${BASE}/categories?accountId=${encodeURIComponent(accountId)}`),
  createUploads: (req) =>
    api(`${BASE}/uploads`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(req),
    }),
  complete: (assetId) => api(`${BASE}/uploads/${encodeURIComponent(assetId)}/complete`, { method: 'POST' }),
};

const json = (body: unknown) => ({
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(body),
});

/**
 * THE CLIENT'S BULK SEAM (Run F). ⚠️ NO `clearPreview`: its absence is what removes the Clear button for a club, and the
 * client route would 400 the op anyway. Results are 200 per asset even when some fail: the bar reads `results`.
 */
export const portalBulkApi: PortalAssetsBulkApi = {
  run: (assetIds, operation) => api(`${BASE}/bulk`, json({ assetIds, operation })),
  enrich: (assetIds) => api(`${BASE}/bulk-enrich`, json({ assetIds })),
};
